import { Box, Grid, makeStyles, Typography, Divider } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { getConditionalText, nKilowattFormatter } from "../../../services";
import { Icon } from "../../../components/base";

const useStyles = makeStyles(() => ({
  mainIcon: {
    width: 60,
    height: 60,
    position: "relative",
    border: `1.5px solid ${COLORS.mikadoYellow}`,
    borderRadius: "100%",
    marginLeft: 20,
  },
  preIcon: {
    position: "absolute",
    top: "-6px",
  },
  divider: {
    height: 10,
    marginTop: 7,
  },
}));

export const SummaryBox = ({
  iconSrc,
  iconBlockStyle,
  preIconSrc,
  preIconStyle,
  text,
  roof,
  parkingLots,
  unitMeasurement = "kWh",
}) => {
  const classes = useStyles();
  const suffix = unitMeasurement[2];

  const getTotal = () => {
    let total = null;
    let uMeasurement = null;

    if (roof !== null && roof >= 0 && !parkingLots) {
      total = roof;
    } else if (!roof && parkingLots !== null && parkingLots >= 0) {
      total = parkingLots;
    } else if (roof !== null && roof >= 0 && parkingLots !== null && parkingLots >= 0) {
      total = roof + parkingLots;
    }
    if (total !== null) {
      const formattedValue = nKilowattFormatter(total, suffix);
      [total, uMeasurement] = formattedValue.split(" ");
    }

    total = getConditionalText(total !== null, total);

    return [total, uMeasurement];
  };
  const [total, uMeasurement] = getTotal();

  return (
    <Box>
      <Grid container>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className={classes.mainIcon}
          style={iconBlockStyle}
        >
          <Icon src={iconSrc} />
          <Icon root={classes.preIcon} src={preIconSrc} style={preIconStyle} />
        </Grid>
        <Grid item xs={9} style={{ marginLeft: 26 }}>
          <Typography>{text}</Typography>
          <Grid container alignItems="baseline" style={{ columnGap: 4, width: "fit-content" }}>
            <Typography variant="h2">Total {total}</Typography>
            <Typography>{uMeasurement}</Typography>
          </Grid>
          <Grid container style={{ columnGap: 10, width: "fit-content" }}>
            <Typography>
              <b>Roof</b> {getConditionalText(roof !== null, nKilowattFormatter(roof, suffix))}
            </Typography>
            {parkingLots ? (
              <>
                <Divider orientation="vertical" className={classes.divider} />
                <Typography>
                  <b>Parking lots</b>{" "}
                  {getConditionalText(
                    parkingLots !== null,
                    nKilowattFormatter(parkingLots, suffix)
                  )}
                </Typography>
              </>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
